<template>
  <div>
    <div class="flex topLine">
      <div
        class="flex1"
        :class="topIndex == 0 ? 'topActive' : ''"
        @click="
          userBankCard = true;
          companyBankCard = false;
          topIndex = 0;
        "
      >
        个人卡包
      </div>
      <div
        class="flex1"
        :class="topIndex == 1 ? 'topActive' : ''"
        @click="
          userBankCard = false;
          companyBankCard = true;
          topIndex = 1;
        "
      >
        公司卡包
      </div>
    </div>
    <div v-if="userBankCard">
      <div v-if="userBankList.length > 0">
        <div class="cardBox" v-for="res in userBankList" :key="res.id">
          <div class="cardLine">
            <div class="cardTop">
              <div class="cardName">
                {{ res.bankName }}
                <span v-if="res.details.length > 0">
                  (
                  <span :key="item.id" v-for="item in res.details">
                    <span v-if="item.bankChannel == 3">{{
                      status[item.auditStatus]
                    }}</span>
                  </span>
                  )
                </span>
              </div>
              <div class="cardNum">
                尾号（{{ res.accountNumber.substr(-4) }}）
              </div>
            </div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户名称:{{ res.details[0].virtualAccountName }}
              <span
                @click="copyInfo(res.details[0].virtualAccountName)"
                style="overflow:hidden;"
              >
                <x-icon
                  style="margin-left: 10px"
                  type="iconxingzhuang"
                  class="icon"
                />
              </span>
            </div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户卡号:{{ res.details[0].virtualAccountNumber }}
              <span
                @click="copyInfo(res.details[0].virtualAccountNumber)"
                style="overflow:hidden;"
              >
                <x-icon
                  style="margin-left: 10px"
                  type="iconxingzhuang"
                  class="icon"
                />
              </span>
            </div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户支行:上海银行宁波分行
            </div>
            <div class="cardMiddle" v-if="res.details.length > 0">
              <div class="moneyTitle">
                <div style="float: left;">充值账户余额（元）</div>
              </div>
              <span class="money" v-if="res.details.length > 0">
                <span :key="item.id" v-for="item in res.details">
                  <span v-if="item.bankChannel == 3">{{
                    item.availableAmount
                  }}</span>
                </span>
              </span>
            </div>
            <!--            <div class="cardBottom flex">-->
            <!--              &lt;!&ndash;                            <div class='cardButton flex1' v-if='res.details.length>0&&res.details[0].bankChannel==3'&ndash;&gt;-->
            <!--              &lt;!&ndash;                                 @click="goWithdraw(res.id)">提现&ndash;&gt;-->
            <!--              &lt;!&ndash;                            </div>&ndash;&gt;-->
            <!--              <div-->
            <!--                v-if="res.details.length <= 0"-->
            <!--                class="cardButton flex1"-->
            <!--                @click="goActive(res.id)"-->
            <!--              >-->
            <!--                激活-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div v-else>
        <Icon type="iconzanwu" class="iconZanwu"></Icon>
        <div class="zanwuContent">暂无银行卡</div>
      </div>
      <div class="add" @click="$router.push('/bankCard/addClientBankCard')">
        <img src="../../assets/add@2x.png" />
      </div>
    </div>

    <div v-if="companyBankCard">
      <div v-if="companyBankList.length > 0">
        <div class="cardBox" v-for="res in companyBankList" :key="res.id">
          <div class="cardLine">
            <div class="cardTop">
              <div class="cardName">
                {{ res.bankName }}
                <span v-if="res.details.length > 0">
                  (
                  <span :key="item.id" v-for="item in res.details">
                    <span v-if="item.bankChannel == 3">{{
                      status[item.auditStatus]
                    }}</span>
                  </span>
                  )
                </span>
              </div>
              <div class="cardNum">
                尾号（{{ res.accountNumber.substr(-4) }}）
              </div>
            </div>
            <span
              class="getMoney"
              v-if="
                res.details.length > 0 &&
                  res.details[0].auditStatus !== 'PASSED'
              "
              @click="accountVerify(res.id, res.companyId)"
              >获取认证信息</span
            >
            <!--						</div>-->
            <div class="clear"></div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户名称:{{ res.details[0].virtualAccountName }}
              <span
                @click="copyInfo(res.details[0].virtualAccountName)"
                style="overflow:hidden;"
              >
                <x-icon
                  style="margin-left: 10px"
                  type="iconxingzhuang"
                  class="icon"
                />
              </span>
            </div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户卡号:{{ res.details[0].virtualAccountNumber }}
              <span
                @click="copyInfo(res.details[0].virtualAccountNumber)"
                style="overflow:hidden;"
              >
                <x-icon
                  style="margin-left: 10px"
                  type="iconxingzhuang"
                  class="icon"
                />
              </span>
            </div>
            <div class="virtual" v-if="res.details.length > 0">
              充值账户支行:上海银行宁波分行
            </div>
            <div class="cardMiddle">
              <div class="moneyTitle">
                <div style="float: left;">充值账户余额（元）</div>
              </div>

              <span class="money" v-if="res.details.length > 0">
                <span :key="item.id" v-for="item in res.details">
                  <span v-if="item.bankChannel == 3">{{
                    item.availableAmount
                  }}</span>
                </span>
              </span>
            </div>
            <!--            <div class="cardBottom flex">-->
            <!--              &lt;!&ndash;                            <div class='cardButton flex1' v-if='res.details.length>0&&res.details[0].bankChannel==3' @click="goWithdraw(res.id)">提现</div>&ndash;&gt;-->
            <!--              <div-->
            <!--                v-if="res.details.length <= 0"-->
            <!--                class="cardButton flex1"-->
            <!--                @click="-->
            <!--                  goCompanyActive(-->
            <!--                    res.id,-->
            <!--                    res.accountNumber,-->
            <!--                    res.companyId,-->
            <!--                    res.bankCode-->
            <!--                  )-->
            <!--                "-->
            <!--              >-->
            <!--                激活-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div v-else>
        <Icon type="iconzanwu" class="iconZanwu"></Icon>
        <div class="zanwuContent">暂无银行卡</div>
      </div>
      <div class="add" @click="$router.push('/bankCard/companySelect')">
        <img src="../../assets/add@2x.png" />
      </div>
    </div>

    <confirm
      v-model="show"
      title="操作提示"
      confirm-text="前去完善"
      @on-cancel="onCancel"
      @on-confirm="onConfirm"
    >
      <p style="text-align:center;">请先完善个人信息,是否前去完善?</p>
    </confirm>

    <confirm v-model="identity" title="认证信息" :show-cancel-button="false">
      <!--            <div class='flex text1'>-->
      <!--                认证打款账户:海上鲜-->
      <!--            </div>-->
      <div class="flex text1">
        户名：上海银行打款激活账户
      </div>
      <div class="flex text1">
        户号：5100107276924262
      </div>
      <div class="flex text1">
        支行：上海银行宁波分行
      </div>
      <div class="flex text1">认证金额:{{ amount }}元</div>
    </confirm>
  </div>
</template>

<script>
import {
  getBankCardList,
  personalComplete,
  accountVerify
} from "../../api/bank";
import { companyBankCardList, companyComplete } from "../../api/company";

export default {
  name: "bankCard",
  data() {
    return {
      status: {
        AUDIT: "审核中",
        PASSED: "审核通过",
        BACK: "审核回退",
        REFUSED: "审核拒绝",
        REMIT_AUDIT: "待打款认证"
      },
      userBankList: [],
      companyBankList: [],
      userBankCard: true,
      companyBankCard: false,
      topIndex: 0,
      show: false,
      companyId: "",
      amount: "",
      identity: false,
      clientId: ""
    };
  },
  created() {
    if (this.$route.query.topIndex) {
      this.topIndex = this.$route.query.topIndex;
    }
    if (this.$route.query.topIndex == 1) {
      this.userBankCard = false;
      this.companyBankCard = true;
    } else {
      this.userBankCard = true;
      this.companyBankCard = false;
    }
    this.getBankCardList();
    this.clientId = this.$store.state.user.userInfo.id;
    this.getCompanyCardList();
  },
  methods: {
    getCompanyCardList() {
      this.$vux.loading.show();
      companyBankCardList({ clientId: this.clientId })
        .then(res => {
          this.$vux.loading.hide();
          this.companyBankList = res;
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    goCompanyActive(id, accountNumber, companyId, bankCode) {
      this.$vux.loading.show();
      companyComplete({ companyId: companyId })
        .then(() => {
          this.$vux.loading.hide();
          this.$router.push({
            path:
              "/bindIdCard/activeCompanyCard?id=" +
              id +
              "&companyId=" +
              companyId +
              "&accountNumber=" +
              accountNumber +
              "&bankCode=" +
              bankCode
          });
        })
        .catch(err => {
          this.$vux.loading.hide();
          if (err.code == 14207) {
            setTimeout(() => {
              const res = confirm(err.msg + "，是否前去完善？");
              if (res) {
                this.$router.push({
                  path: "/user/identity?from=cardList"
                });
              }
            }, 100);
          }
          if (err.code == 14208) {
            setTimeout(() => {
              const res = confirm(err.msg + "，是否前去完善？");
              if (res) {
                this.$router.push({
                  path:
                    "/identify/companyEdit/" +
                    companyId +
                    "?from=cardList&&id=" +
                    companyId
                });
              }
            }, 100);
          }
          // setTimeout(() => {
          //   const res = confirm(err + "，是否前去完善？");
          //   if (res) {
          //     this.$router.push({
          //       path:
          //         "/identify/companyEdit/" +
          //         companyId +
          //         "?from=cardList&&id=" +
          //         companyId
          //     });
          //   }
          // }, 100);
        });
    },
    accountVerify(id, companyId) {
      this.amount = "";
      this.$vux.loading.show();
      accountVerify({ bankCardId: id, companyId: companyId })
        .then(res => {
          this.identity = true;
          this.$vux.loading.hide();
          this.amount = res.amount;
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    getBankCardList() {
      this.$vux.loading.show();
      getBankCardList({})
        .then(res => {
          this.$vux.loading.hide();
          this.userBankList = res;
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    onConfirm() {
      this.$router.push({ path: "/my/identity" });
    },
    goActive(id) {
      personalComplete({})
        .then(() => {
          this.$router.push({ path: "/bindIdCard/bindStep2?id=" + id });
        })
        .catch(err => {
          this.show = true;
          this.$showError(err);
        });
    },

    goWithdraw(id) {
      this.$router.push({ path: "/withdraw/withdraw?id=" + id });
    }
  }
};
</script>

<style scoped>
.text1 {
  margin: 20px 0px;
  font-size: 16px;
  line-height: 48px;
}
.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.clear {
  clear: both;
}

.bankCardBox {
  margin: 20px;
  overflow: hidden;
}

.add {
  width: 90px;
  height: 90px;
  position: fixed;
  right: 60px;
  bottom: 60px;
  z-index: 1;
}

.add img {
  width: 100%;
  height: 100%;
}

.iconZanwu {
  width: 246px !important;
  height: 246px !important;
  margin: 260px auto 0 auto;
  display: block;
}

.zanwuContent {
  text-align: center;
  color: #ababab;
  font-size: 14px;
  margin-top: 73px;
  margin-bottom: 88px;
}

.topLine {
  height: 80px;
  line-height: 79px;
  font-size: 14px;
  color: #333333;
  text-align: center;
  background: #fff;
  padding: 0 40px;
}

.topActive {
  color: #007bec;
  border-bottom: 1px solid #007bec;
}

.cardBox {
  margin: 20px;
  border-radius: 10px;
  overflow: hidden;
  background: url(../../assets/bankCardBg.png);
  background-size: cover;
  color: #fff;
}

.cardTop {
  margin: 50px 0 66px 0;
  padding: 0 30px;
  display: block;
  overflow: hidden;
}

.cardName {
  font-size: 16px;
  line-height: 40px;
  float: left;
}

.cardNum {
  float: right;
  font-size: 12px;
  line-height: 40px;
}

.cardMiddle {
  padding: 0 30px;
  font-size: 12px;
  line-height: 40px;
  overflow: hidden;
  margin-bottom: 36px;
}

.money {
  font-size: 16px;
}

.cardBottom {
  background: #b83432;
  height: 80px;
  line-height: 80px;
  font-size: 15px;
  text-align: center;
}

.moneyTitle {
  overflow: hidden;
}
.virtual {
  display: block;
  font-size: 14px;
  padding: 4px 30px;
  overflow: hidden;
}
.getMoney {
  display: block;
  float: left;
  margin-left: 20px;
  padding: 6px 20px;
  height: 40px;
  font-size: 12px;
  line-height: 40px;
  background: #b83432;
  text-align: center;
  border: 2px solid #fff;
  border-radius: 6px;
}
</style>
